import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeesComponent } from './employees/employees.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';
import { BenefitsComponent } from './benefits/benefits.component';
import { ExchangeBenefitsComponent } from './exchange-benefits/exchange-benefits.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { NewBenefitComponent } from './new-benefit/new-benefit.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeeTransactionHistoryComponent } from './employee-transaction-history/employee-transaction-history.component';
import { EmployeeGuestBookingComponent } from './employee-guest-booking/employee-guest-booking.component';
import { EmployeeExchangeBenefitsComponent } from './employee-exchange-benefits/employee-exchange-benefits.component';
import { EmployeeCommentsComponent } from './employee-comments/employee-comments.component';
import { ExchangeBenefitsDetailsComponent } from './exchange-benefits-details/exchange-benefits-details.component';

const routes: Routes = [
  {
    path: 'employees', component: EmployeesComponent, canActivate: [AuthGuard],
    children: [
      { path: 'benefits', pathMatch: 'full', component: BenefitsComponent, canActivate: [AuthGuard] },
      {path: 'benefits/add', component: NewBenefitComponent, canActivate: [AuthGuard]},
      {path: 'benefits/edit/:id', component: NewBenefitComponent, canActivate: [AuthGuard]},
      // children: [
        
      // ] },
      { path: 'exchange-benefits', pathMatch: 'full', component: ExchangeBenefitsComponent, canActivate: [AuthGuard] },
      { path: 'exchange-benefits/add', pathMatch: 'full', component: ExchangeBenefitsDetailsComponent, canActivate: [AuthGuard] },
      { path: 'exchange-benefits/edit/:id', pathMatch: 'full', component: ExchangeBenefitsDetailsComponent, canActivate: [AuthGuard] },
      { path: 'employee-list', pathMatch: 'full', component: EmployeeListComponent, canActivate: [AuthGuard] },
      { path: 'employee-list/add', component: EmployeeDetailsComponent, canActivate: [AuthGuard] },
      { path: 'employee-list/edit/:id', component: EmployeeDetailsComponent, canActivate: [AuthGuard],
      children: [
        { path: '', pathMatch: 'full', component: EmployeeTransactionHistoryComponent },
        { path: 'guest-booking', pathMatch: 'full', component: EmployeeGuestBookingComponent, canActivate: [AuthGuard] },
        { path: 'transaction-history', pathMatch: 'full', component: EmployeeTransactionHistoryComponent, canActivate: [AuthGuard] },
        { path: 'exchange-benefits', pathMatch: 'full', component: EmployeeExchangeBenefitsComponent, canActivate: [AuthGuard] },
        { path: 'comments', pathMatch: 'full', component: EmployeeCommentsComponent, canActivate: [AuthGuard] }
      ] },
      // { path: 'employee-list/edit/:id/transaction-history', pathMatch: 'full', component: EmployeeTransactionHistoryComponent, canActivate: [AuthGuard] },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employees-routing.module.ts